import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageLinesFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.25 0.75H1.75C0.765625 0.75 0 1.54297 0 2.5V10.375C0 11.3594 0.765625 12.125 1.75 12.125H4.375V14.4219C4.375 14.6953 4.67578 14.8594 4.89453 14.6953L8.3125 12.125H12.25C13.207 12.125 14 11.3594 14 10.375V2.5C14 1.54297 13.207 0.75 12.25 0.75ZM7.21875 8.625H4.15625C3.77344 8.625 3.5 8.35156 3.5 7.96875C3.5 7.61328 3.77344 7.3125 4.15625 7.3125H7.21875C7.57422 7.3125 7.875 7.61328 7.875 7.96875C7.875 8.35156 7.57422 8.625 7.21875 8.625ZM9.84375 6H4.15625C3.77344 6 3.5 5.72656 3.5 5.34375C3.5 4.98828 3.77344 4.6875 4.15625 4.6875H9.84375C10.1992 4.6875 10.5 4.98828 10.5 5.34375C10.5 5.72656 10.1992 6 9.84375 6Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgMessageLinesFilled);
export { ForwardRef as ReactComponent };
